import { FilterOperatorProps } from '../contracts/FilterOperatorProps';

const filterConstraints = ['is'] as const;
export type BooleanFilterConstraints = (typeof filterConstraints)[number];

const BooleanOperators: FilterOperatorProps<BooleanFilterConstraints> = {
	icon: 'Check',
	filterConstraints,
	humanNames: {
		is: 'is'
	}
};
export default BooleanOperators;
